import { PropsWithChildren, ReactNode } from 'react';

import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { StatusType } from './StateStatus';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '100%',
    marginRight: 8,
    flexShrink: 0,
  },
  ok: {
    backgroundColor: theme.palette.success.main,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  pending: {
    backgroundColor: theme.palette.info.main,
  },
  running: {
    backgroundColor: theme.palette.info.main,
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },
  aborted: {
    backgroundColor: theme.palette.grey[500],
  },
}));

interface StatusProps {
  type: StatusType;
  children: ReactNode;
}

export const StateStatusMui = ({ type, children }: StatusProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classNames(classes.dot, classes[type])} />
      {children}
    </div>
  );
};

export const StatusOKMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.OK}>{children}</StateStatusMui>
);

export const StatusWarningMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.WARNING}>{children}</StateStatusMui>
);

export const StatusErrorMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.ERROR}>{children}</StateStatusMui>
);

export const StatusPendingMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.PENDING}>{children}</StateStatusMui>
);

export const StatusRunningMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.RUNNING}>{children}</StateStatusMui>
);

export const StatusAbortedMui = ({ children }: PropsWithChildren) => (
  <StateStatusMui type={StatusType.ABORTED}>{children}</StateStatusMui>
);
